import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown';
import { faCaretUp } from '@fortawesome/pro-solid-svg-icons/faCaretUp';
import { faCaretRight } from '@fortawesome/pro-solid-svg-icons/faCaretRight';
import { faCaretLeft } from '@fortawesome/pro-solid-svg-icons/faCaretLeft';

import React from 'react';
import { FormattedMessage } from 'react-intl';

import { messages as moveToPreviousMessages } from '../go-to-previous-modal';
import { messages as moveToNextMessages } from '../go-to-next-modal';
import { messages as closeModalMessages } from '../close-modal';
import { hotkey as listHotkeysHotkey, messages as listHotkeysMessages } from '../list-hotkeys';

import HotkeySectionLineItem from './line-item';
import { useCtrlOrCmd } from './hooks';
import messages from './messages';
import style from './style.module.less';

const GeneralHotkeys = () => {
  const ctrlOrCmd = useCtrlOrCmd();

  return (
    <>
      <HotkeySectionLineItem hotkey={listHotkeysHotkey} name={<FormattedMessage {...listHotkeysMessages.name} />} />
      <HotkeySectionLineItem hotkey={<FormattedMessage {...messages.escape} />} name={<FormattedMessage {...closeModalMessages.name} />} />
      <HotkeySectionLineItem
        hotkey={<FormattedMessage {...messages.shiftClick} />}
        name={<FormattedMessage {...messages.selectMultipleRows} />}
      />
      <HotkeySectionLineItem
        hotkey={<FormattedMessage {...messages.ctrlOrCmdClick} values={{ ctrlOrCmd }} />}
        name={<FormattedMessage {...messages.toggleRowSelection} />}
      />
      <HotkeySectionLineItem
        hotkey={<FontAwesomeIcon className={style.icon} icon={faCaretDown} />}
        name={<FormattedMessage {...messages.moveToNextRow} />}
      />
      <HotkeySectionLineItem
        hotkey={<FontAwesomeIcon className={style.icon} icon={faCaretUp} />}
        name={<FormattedMessage {...messages.moveToPreviousRow} />}
      />
      <HotkeySectionLineItem
        hotkey={<FontAwesomeIcon className={style.icon} icon={faCaretRight} />}
        name={<FormattedMessage {...moveToNextMessages.name} />}
      />
      <HotkeySectionLineItem
        hotkey={<FontAwesomeIcon className={style.icon} icon={faCaretLeft} />}
        name={<FormattedMessage {...moveToPreviousMessages.name} />}
      />
      <HotkeySectionLineItem
        hotkey={<FormattedMessage {...messages.ctrlOrCmdShiftS} values={{ ctrlOrCmd }} />}
        name={<FormattedMessage {...messages.openScanToSearch} />}
      />
    </>
  );
};

export default GeneralHotkeys;
